// extracted by mini-css-extract-plugin
export var box = "_3j-0";
export var check = "_3j-1";
export var checkboxButton = "_3j-6";
export var checkboxGroup = "_3j-5";
export var disabled = "_3j-7";
export var ghost = "_3j-9";
export var input = "_3j-2";
export var label = "_3j-4";
export var normal = "_3j-8";
export var uncheck = "_3j-3";